import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

interface ParagraphVacanciesFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphVacanciesFiltered: React.FC<ParagraphVacanciesFilteredProps> = () => (
  <div className="Paragraph ParagraphVacanciesFiltered">
    <Container>
      <View
        classes="row"
        id="vacancies_filtered"
        display="vacancies_filtered"
        withProvider
      />
    </Container>
  </div>
);

export default ParagraphVacanciesFiltered;
